<input
    type="number"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [value]="value"
    (input)="onValueChange($event)"
    (blur)="formatValue($event)"
    class="form-control"
/>
